import { API_BASE_URL } from "../config/apiBase";
import { normalizeStudentId } from "../utils/studentRoutes";

const API = API_BASE_URL;

export async function markCurrentLessonCompleteBeforeReflection({ studentId, week, lesson }) {
  const canonicalStudentId = normalizeStudentId(studentId);
  if (!canonicalStudentId || !week || !lesson) return false;
  try {
    const res = await fetch(`${API}/api/weekly-reflection/mark-complete`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        student_id: canonicalStudentId,
        week,
      }),
    });
    return Boolean(res && res.ok);
  } catch {
    return false;
  }
}
